export const extractCssVariableValue = (variableName: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(variableName)
